export enum NotificationType {
  Undefined = 'undefined',
  SMS = 'sms',
  Email = 'email',
  Push = 'push',
}
